import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reported: 0,
  assigned: 0,
  total: 0
}

const unreadOrderSupportRequestsSlice = createSlice({
  name: 'unreadOrderSupportRequests',
  initialState,
  reducers: {

    setUnreadOrderSupportRequests: (state, { payload: { unreadOrderSupportRequests } }) => {
      state.reported = unreadOrderSupportRequests.reported;
      state.assigned = unreadOrderSupportRequests.assigned;
      state.total = unreadOrderSupportRequests.total;
    },
    decrementReported: (state) => {
      state.reported -= 1;
      state.total -= 1;
    },
    decrementAssigned: (state) => {
      state.assigned -= 1;
      state.total -= 1;
    }
  }
});

export const getUnreadOrderSupportRequests = state => state.unreadOrderSupportRequests;

export const { setUnreadOrderSupportRequests, decrementReported, decrementAssigned } = unreadOrderSupportRequestsSlice.actions;

export default unreadOrderSupportRequestsSlice.reducer;